/*
 * Quiz V4 section order
 * Basics
 * 1 - Hormones (hormones-women/hormones-men)
 * 2 - Stress
 * 3 - Lifestyle (old Environment)
 * 4 - Metabolism
 * 5 - Nutrition
 * 6 - Aging
 * Save Results
 * Results
 */

export const moreQuestions = (currentStep, totalSteps) => {
  return currentStep < totalSteps
}

export const getNextSection = (currentSection) => {
  if (!!currentSection) {
    if (currentSection === "basics") {
      return "hair-history"
    }
    if (currentSection === "hair-history") {
      return "save-results"
    }
  }
  return "basics"
}

export const getPreviousSection = (currentSection) => {

  if (!!currentSection) {
    if (currentSection === "results") {
      return "hair-history"
    }
  }

  return "basics"
}
